<template>
  <div class="home">
    <img src="https://www.johnnys-net.jp/material/AMIfv952HJJ5G0ybmyAcmMLg6zmyPYlv3sgx1hWnuYNJ0I_7CxyFTi3yU8gFex1Jmtu31aYTK1MBLs4FocQL3l7Hwevur7PF34lylmX32QBiNKOii9ddDVsgMf0EXbrw20xug0Fdjzp-5jFeBUKUCtqjuykzOiTII4rSftHvez0tQtROlXXtK3c?c=0&m=image%2Fjpeg">
    <div class="description">
      5人で嵐です。
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
}
</script>

<style lang="scss" scoped>
@import '../assets/global.scss';
.home img {
  width: 800px;
  height: auto;
  align-self: center;
}
.description {
  margin-top: 40px;
  color: transparentize($color: $pantone-m, $amount: 0.5);
  font-weight: bold;
}

</style>
